import { NgModule } from '@angular/core';
import { ImageAuthPipe } from './pipes/image-auth';
import { SafePipe } from './pipes/safe';
import { IsDeletableDocumentPipe } from './pipes/is-deletable-document';
import { AreDeletableDocumentsPipe } from './pipes/are-deletable-documents';
import { WithLoadingPipe } from './pipes/with-loading-pipe';
import { PurifyPipe } from './pipes/purify';
import { MdrReportDatePipe } from './pipes/mdr-report-date.pipe';
import { RemoveBarEmptyCategoriesPipe } from './pipes/remove_empty_categories.pipe';
import { RemoveAreaEmptyCategoriesPipe } from './pipes/remove-empty-area-categories.pipe';

@NgModule({
    declarations: [
        ImageAuthPipe,
        SafePipe,
        IsDeletableDocumentPipe,
        AreDeletableDocumentsPipe,
        WithLoadingPipe,
        PurifyPipe,
        MdrReportDatePipe,
        RemoveBarEmptyCategoriesPipe,
        RemoveAreaEmptyCategoriesPipe,
    ],
    exports: [
        ImageAuthPipe,
        SafePipe,
        IsDeletableDocumentPipe,
        AreDeletableDocumentsPipe,
        WithLoadingPipe,
        PurifyPipe,
        MdrReportDatePipe,
        RemoveBarEmptyCategoriesPipe,
        RemoveAreaEmptyCategoriesPipe,
    ],
    imports: [],
    providers: [IsDeletableDocumentPipe],
})
export class PipesModule {}
